// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__q54OF","warning":"Banner_warning__CXrkX","success":"Banner_success__JVYO9"};